module.exports = __webpack_public_path__ + "img/van-shuttle.9d55b624.svg";